var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbdown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0H15H4.693C3.864 0 3.112 0.521 2.82 1.298L0.063 8.649C0.021 8.761 0 8.88 0 9V11C0 12.103 0.897 13 2 13H7.612L6.49 16.367C6.287 16.975 6.389 17.649 6.764 18.169C7.14 18.689 7.746 19 8.388 19H10C10.297 19 10.578 18.868 10.769 18.64L15.469 13H18C19.103 13 20 12.103 20 11V2C20 0.897 19.103 0 18 0ZM9.531 17H8.386L9.948 12.316C10.051 12.011 9.999 11.676 9.811 11.415C9.623 11.154 9.321 11 9 11H2V9.181L4.693 2H14V11.638L9.531 17ZM16 11V2H18L18.001 11H16Z",
    fill: "#DBD2CA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbdown);
export default __webpack_public_path__ + "static/media/thumbdown.04a23b06.svg";
export { ForwardRef as ReactComponent };